import scrollLock from "./scroll-lock";

export default function headerNav() {
    const header = document.querySelector(".header");
    const burgerBtn = header.querySelector(".header-burger-btn");
    const headerLinks = header.querySelectorAll("a");
    const headerSection = document.querySelector(".header-section");
    const scrollButton = document.querySelector(".header-section-scroll-btn");
    let headerIndent;

    const handleHeaderPosition = () => {
        if (headerSection && !header.classList.contains("menu-is-open")) {
            headerIndent = headerSection.scrollHeight;
            if (window.innerWidth >= 1200) {
                headerIndent = headerSection.scrollHeight - header.offsetHeight;
            }

            header.style.position = "absolute";
            header.style.top = `${headerIndent}px`;

            if (window.pageYOffset >= headerIndent) {
                header.style.removeProperty("position");
                header.style.removeProperty("top");
            }
        }

        if (!headerSection && (window.pageYOffset > header.offsetHeight)) {
            header.classList.add("is-scrolled");
        } else {
            header.classList.remove("is-scrolled");
        }
    };

    const handleScrollLock = () => {
        header.classList.contains("menu-is-open") ? scrollLock.enable() : scrollLock.disable();

        if (headerSection) {
            if (header.classList.contains("menu-is-open")) {
                header.style.removeProperty("position");
                header.style.removeProperty("top");
            } else {
                header.style.position = "absolute";
                header.style.top = `${headerIndent}px`;
            }
        }
    };

    const handleBurgerMenu = (type = "toggle") => () => {
        (type === "toggle") && header.classList.toggle("menu-is-open");
        (type === "close") && header.classList.remove("menu-is-open");
        handleScrollLock();
    };

    const handleHeaderEvents = () => {
        if (window.innerWidth < 1024) {
            headerLinks.forEach((link) => link.addEventListener("click", handleBurgerMenu("close")));
        } else {
            handleBurgerMenu("close");
        }
        handleHeaderPosition();
    };

    handleHeaderEvents();
    window.addEventListener("resize", handleHeaderEvents);
    window.addEventListener("scroll", handleHeaderPosition);
    burgerBtn && burgerBtn.addEventListener("click", handleBurgerMenu("toggle"));
    scrollButton && scrollButton.addEventListener("click", () => headerSection && window.scrollTo({
        top: headerSection.scrollHeight,
        behavior: "smooth"
    }));
}



// WEBPACK FOOTER //
// ./assets/js/modules/header-nav.js